export default __webpack_public_path__ + "static/media/card.9ae6b2f7.png";